import '../orderPage/orderCompletion/OrderCompletedPage.scss';
import { CheckCircle } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';

type CardUpdatedPageProps = {
  cardSuffix?: string;
  nextChargeDate?: string;
};

export const CardUpdatedPage = ({ cardSuffix, nextChargeDate }: CardUpdatedPageProps) => {
  const { t, i18n } = useTranslation();

  const elementRef = useCallback((node: HTMLDivElement | null) => {
    if (!node) return;
    const resizeObserver = new ResizeObserver(() => {
      window.parent.postMessage({ height: document.body.offsetHeight }, '*');
    });
    resizeObserver.observe(node);
  }, []);

  return (
    <div className="order-completed-page" dir={i18n.dir()} ref={elementRef}>
      <div className="order-completed-page-box">
        <CheckCircle className="order-completed-icon" />
        <div className="title">{t('manage_passes.membership.cardUpdated.title')}</div>
        <div className="sub-text">{t('manage_passes.membership.cardUpdated.subText')}</div>
        {(cardSuffix || nextChargeDate) && (
          <Grid container flexDirection="column" gap={1} mt={3} px={4}>
            {cardSuffix && (
              <Grid container justifyContent="space-between">
                <Typography color="text.secondary">{t('card_update.cardOnFile')}</Typography>
                <Typography dir="ltr" fontWeight={600}>
                  •••• {cardSuffix}
                </Typography>
              </Grid>
            )}
            {nextChargeDate && (
              <Grid container justifyContent="space-between">
                <Typography color="text.secondary">{t('card_update.nextCharge')}</Typography>
                <Typography fontWeight={600}>{nextChargeDate}</Typography>
              </Grid>
            )}
          </Grid>
        )}
      </div>
    </div>
  );
};

export default CardUpdatedPage;
